import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import {
	ImageUploadCallback,
	imageUploadCallbackAtom,
	QuickImageGenerateCallback,
	quickImageGenerateCallbackAtom,
	QuickImageUploadCallback,
	quickImageUploadCallbackAtom,
} from '../ui'

export type UseEditorDirectImageToolsProps = {
	onImageUpload: ImageUploadCallback
	onQuickImageUpload: QuickImageUploadCallback
	onQuickImageGenerate: QuickImageGenerateCallback
}

/**
 * Hook that sets image callback functions in atoms.
 * This allows widgets to access these callbacks without prop drilling.
 */
export function useEditorDirectImageTools({
	onImageUpload,
	onQuickImageUpload,
	onQuickImageGenerate,
}: UseEditorDirectImageToolsProps) {
	const setImageUploadCallback = useSetAtom(imageUploadCallbackAtom)
	const setQuickImageUploadCallback = useSetAtom(quickImageUploadCallbackAtom)
	const setQuickImageGenerateCallback = useSetAtom(quickImageGenerateCallbackAtom)

	useEffect(() => {
		setImageUploadCallback(() => onImageUpload)
		setQuickImageUploadCallback(() => onQuickImageUpload)
		setQuickImageGenerateCallback(() => onQuickImageGenerate)
	}, [
		onImageUpload,
		onQuickImageUpload,
		onQuickImageGenerate,
		setImageUploadCallback,
		setQuickImageUploadCallback,
		setQuickImageGenerateCallback,
	])
}
